import {createEntitySlice} from 'utils/createEntitySlice';
import {BillingSolution} from 'types/billingSolution';
import {BillingSolutionThunks} from 'features/programs/program/billingSolution/billingSolutionThunks';

export interface BillingSolutionState {
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
  billingSolutions?: any;
  pagy?: any;
  billingSolution?: any;
  isEditing?: boolean;
}
const initialState: BillingSolutionState = {
  status: 'idle',
  error: null,
  billingSolutions: [],
  billingSolution: {name: '', conversionType: '', aggregation: '', period: ''},
  pagy: {},
  isEditing: false,
};
const billingSolutionSlice = createEntitySlice<BillingSolution>({
  name: 'Billing Solution',
  initialState,
  thunks: BillingSolutionThunks,
  entityKey: 'billingSolution',
  entitiesKey: 'billingSolutions',
  reducers: {},
});

export const {setEntity: setBillingSolution, setIsEditing} =
  billingSolutionSlice.actions;
export {initialState as billingSolutionInitialState};
export default billingSolutionSlice.reducer;
